import { render, staticRenderFns } from "./CreateClientAccount.vue?vue&type=template&id=2641d130&"
import script from "./CreateClientAccount.vue?vue&type=script&lang=js&"
export * from "./CreateClientAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports